(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ia-feature-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = '1';

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    if (!track || slides.length < 2) return;

    var index = 0;

    function syncDots(i) {
      dots.forEach(function (d) {
        var di = parseInt(d.getAttribute('data-carousel-dot'), 10);
        var on = di === i;
        d.classList.toggle('is-active', on);
        if (on) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      syncDots(index);
    }

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        go(parseInt(d.getAttribute('data-carousel-dot'), 10));
      });
    });

    var raf;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (s, si) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = si; }
        });
        index = nearest;
        syncDots(index);
      });
    });
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-carousel]')).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ia-testimonials"] && !Shopify.designMode) return;
  try {
    
(function () {
  function wrap(i, n) {
    return ((i % n) + n) % n;
  }

  function init(root) {
    if (root.dataset.reviewsReady) return;
    root.dataset.reviewsReady = '1';

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-reviews-panel]'));
    var captions = Array.prototype.slice.call(root.querySelectorAll('[data-reviews-caption]'));
    var n = panels.length;
    if (!n) return;

    var index = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function paint() {
      panels.forEach(function (panel, i) {
        var offset = wrap(i - index, n);
        var open = offset === 0;
        panel.style.order = String(offset);
        panel.dataset.col = String(offset);
        panel.classList.toggle('is-open', open);
        panel.setAttribute('aria-selected', open ? 'true' : 'false');
        panel.tabIndex = open ? 0 : -1;
      });
      captions.forEach(function (cap, i) {
        var on = i === index;
        cap.classList.toggle('is-active', on);
        if (on) {
          cap.removeAttribute('aria-hidden');
        } else {
          cap.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function go(to) {
      index = wrap(to, n);
      paint();
    }

    panels.forEach(function (panel) {
      panel.addEventListener('click', function () {
        var next = parseInt(panel.getAttribute('data-index'), 10);
        if (next === index) return;
        go(next);
      });
    });

    var prev = root.querySelector('[data-reviews-prev]');
    var next = root.querySelector('[data-reviews-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    var strip = root.querySelector('[data-reviews-strip]');
    if (strip && n > 1) {
      strip.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        }
      });
    }

    if (reduced) root.style.setProperty('--rv-ms', '0ms');
    paint();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-reviews]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function () {
  function init() {
    var frames = Array.prototype.slice.call(document.querySelectorAll('[data-frame]'));
    var thumbs = Array.prototype.slice.call(document.querySelectorAll('[data-thumb]'));

    // --- troca de imagem pela trilha de thumbs
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = t.dataset.thumb;
        frames.forEach(function (f) { f.classList.toggle('hidden', f.dataset.frame !== i); });
        thumbs.forEach(function (o) { o.classList.toggle('is-active', o === t); });
      });
    });

    // --- zoom por hover (2x, transform-origin seguindo o mouse)
    // Igual ao ProductImageZoom.tsx: só em dispositivos com hover real.
    if (window.matchMedia('(hover: hover)').matches) {
      document.querySelectorAll('[data-zoom]').forEach(function (frame) {
        var img = frame.querySelector('[data-zoom-img]');
        if (!img) return;

        frame.addEventListener('mousemove', function (e) {
          var r = frame.getBoundingClientRect();
          var x = ((e.clientX - r.left) / r.width) * 100;
          var y = ((e.clientY - r.top) / r.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          img.style.transform = 'scale(2)';
        });
        frame.addEventListener('mouseleave', function () {
          img.style.transform = '';
          img.style.transformOrigin = '';
        });
      });
    }

    // --- lightbox
    var dialog = document.querySelector('[data-lightbox]');
    if (!dialog || !dialog.showModal) return;
    var dialogImg = dialog.querySelector('[data-lightbox-img]');

    document.querySelectorAll('[data-lightbox-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var frame = btn.closest('[data-frame]');
        var img = frame && frame.querySelector('[data-zoom-img]');
        if (!img) return;
        dialogImg.src = img.src;
        dialogImg.alt = img.alt;
        dialog.showModal();
      });
    });

    var close = dialog.querySelector('[data-lightbox-close]');
    if (close) close.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('click', function (e) { if (e.target === dialog) dialog.close(); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-wishlist"]) return;
  try {
    
(function () {
  function key() {
    return (window.VELU && window.VELU.settings && window.VELU.settings.wishlistKey) || 'velu-wishlist';
  }

  function read() {
    try {
      var raw = localStorage.getItem(key());
      if (!raw) return [];
      return (JSON.parse(raw).state || {}).handles || [];
    } catch (e) { return []; }
  }

  function money(cents) {
    return (cents / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  }

  function installments(cents) {
    return '6x de ' + money(Math.round(cents / 6)) + ' sem juros';
  }

  function card(p) {
    var img = p.featured_image
      ? '<img src="' + p.featured_image + '&width=600" alt="" width="600" height="750" loading="lazy">'
      : '';
    var badge = p.available ? '' : '<span class="product-card__badge">Esgotado</span>';
    return (
      '<div class="product-card' + (p.available ? '' : ' product-card--sold-out') + '">' +
        '<a href="' + p.url + '" class="product-card__media">' + img + badge + '</a>' +
        '<button type="button" class="wishlist-btn" data-wishlist-toggle data-handle="' + p.handle + '" aria-pressed="true" aria-label="Remover dos favoritos">' +
          '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>' +
        '</button>' +
        '<a href="' + p.url + '" class="product-card__title text-body-md">' + p.title + '</a>' +
        '<span class="product-card__price">' +
          '<span class="price">' +
            '<span class="price__row"><span class="price__current">' + money(p.price) + '</span></span>' +
            '<span class="price__installments">' + installments(p.price) + '</span>' +
          '</span>' +
        '</span>' +
      '</div>'
    );
  }

  function render() {
    var grid = document.querySelector('[data-wishlist-grid]');
    var empty = document.querySelector('[data-wishlist-empty]');
    if (!grid) return;

    var handles = read();
    if (!handles.length) {
      grid.hidden = true;
      grid.innerHTML = '';
      if (empty) empty.hidden = false;
      return;
    }

    Promise.all(
      handles.map(function (h) {
        return fetch('/products/' + h + '.js')
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })
    ).then(function (products) {
      var found = products.filter(Boolean);
      if (!found.length) {
        grid.hidden = true;
        if (empty) empty.hidden = false;
        return;
      }
      grid.innerHTML = found.map(card).join('');
      grid.hidden = false;
      if (empty) empty.hidden = true;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', render);
  } else {
    render();
  }
  document.addEventListener('velu:wishlist:change', render);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-squeeze"] && !Shopify.designMode) return;
  try {
    
(function () {
  function wrap(i, n) {
    return ((i % n) + n) % n;
  }

  function init(root) {
    if (root.dataset.squeezeReady) return;
    root.dataset.squeezeReady = '1';

    var panels = Array.prototype.slice.call(root.querySelectorAll('[data-squeeze-panel]'));
    var captions = Array.prototype.slice.call(root.querySelectorAll('[data-squeeze-caption]'));
    var n = panels.length;
    if (!n) return;

    var index = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileMq = window.matchMedia('(max-width: 767px)');
    var strip = root.querySelector('[data-squeeze-strip]');
    var ready = false;

    function paint(animate) {
      var mobile = mobileMq.matches;
      var stripW = strip ? strip.clientWidth : 0;
      var gap = mobile || n < 2 ? 0 : parseFloat(getComputedStyle(root).getPropertyValue('--sq-gap')) || 12;
      var inner = Math.max(0, stripW - gap * Math.max(0, n - 1));
      var openW = mobile || n === 1 ? inner : inner * 0.5;
      var restW = mobile || n === 1 ? 0 : (inner - openW) / (n - 1);

      root.style.setProperty('--sq-ms', !ready || !animate || reduced ? '0ms' : '500ms');

      panels.forEach(function (panel, i) {
        var open = i === index;
        panel.style.width = (open ? openW : restW) + 'px';
        panel.classList.toggle('is-open', open);
        panel.setAttribute('aria-selected', open ? 'true' : 'false');
        panel.tabIndex = open ? 0 : -1;
      });
      captions.forEach(function (cap, i) {
        var on = i === index;
        cap.classList.toggle('is-active', on);
        if (on) {
          cap.removeAttribute('aria-hidden');
        } else {
          cap.setAttribute('aria-hidden', 'true');
        }
      });

      if (!ready) {
        requestAnimationFrame(function () {
          ready = true;
          if (!reduced) root.style.setProperty('--sq-ms', '500ms');
        });
      }
    }

    function go(to) {
      index = wrap(to, n);
      paint(true);
    }

    panels.forEach(function (panel) {
      panel.addEventListener('click', function () {
        var next = parseInt(panel.getAttribute('data-index'), 10);
        if (next === index) return;
        go(next);
      });
    });

    var prev = root.querySelector('[data-squeeze-prev]');
    var next = root.querySelector('[data-squeeze-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); });
    if (next) next.addEventListener('click', function () { go(index + 1); });

    if (strip && n > 1) {
      strip.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        } else if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        }
      });
    }

    if (reduced) root.style.setProperty('--sq-ms', '0ms');
    paint(false);

    if (strip && window.ResizeObserver) {
      var lastW = 0;
      new ResizeObserver(function (entries) {
        var w = entries[0] ? entries[0].contentRect.width : 0;
        if (Math.round(w) === Math.round(lastW)) return;
        lastW = w;
        paint(false);
      }).observe(strip);
    } else {
      window.addEventListener('resize', function () { paint(false); });
    }
    if (mobileMq.addEventListener) {
      mobileMq.addEventListener('change', function () { paint(false); });
    } else if (mobileMq.addListener) {
      mobileMq.addListener(function () { paint(false); });
    }
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-squeeze]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promo-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initCarousel(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = '1';

    var track = root.querySelector('[data-carousel-track]');
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-slide]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-carousel-dot]'));
    if (!track || slides.length < 2) return;

    var index = 0;
    var delay = parseInt(root.dataset.autoplay, 10) || 5000;
    var timer = null;

    function syncDots(i) {
      dots.forEach(function (d, di) {
        d.classList.toggle('is-active', di === i);
        if (di === i) {
          d.setAttribute('aria-current', 'true');
        } else {
          d.removeAttribute('aria-current');
        }
      });
    }

    function go(i) {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      syncDots(index);
    }

    function start() {
      stop();
      timer = window.setInterval(function () { go(index + 1); }, delay);
    }

    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (prev) prev.addEventListener('click', function () { go(index - 1); start(); });
    if (next) next.addEventListener('click', function () { go(index + 1); start(); });
    dots.forEach(function (d, di) {
      d.addEventListener('click', function () { go(di); start(); });
    });

    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', function (e) {
      if (!root.contains(e.relatedTarget)) start();
    });

    var raf;
    track.addEventListener('scroll', function () {
      window.cancelAnimationFrame(raf);
      raf = window.requestAnimationFrame(function () {
        var nearest = 0;
        var best = Infinity;
        slides.forEach(function (s, si) {
          var d = Math.abs(s.offsetLeft - track.offsetLeft - track.scrollLeft);
          if (d < best) { best = d; nearest = si; }
        });
        index = nearest;
        syncDots(index);
      });
    });

    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) start();
  }

  function initAll() {
    Array.prototype.slice.call(document.querySelectorAll('[data-carousel]')).forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();

  } catch(e) { console.error(e); }
})();
})();
